var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"select-component design-component",class:_vm.cssArray,on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.select($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }